import { render, staticRenderFns } from "./ChangeAccount.vue?vue&type=template&id=47423c2e"
import script from "./ChangeAccount.vue?vue&type=script&lang=js"
export * from "./ChangeAccount.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccount.vue?vue&type=style&index=0&id=47423c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports